<template>
    <div>
        <app-bar :backBtn="{ visible: userInfo.role.id !== 'MERCHANT' ? true : false }">
            <template #title> {{ merchantDetails.name }} </template>
            <template #status>
                <div class="rounded text-center mx-4 font-weight-medium text-caption py-1 px-4" :class="['status', merchantDetails.status.toLowerCase()]">{{ merchantDetails.status | uppercaseFirst }}</div>
            </template>
            <template v-if="(merchantDetails.schedule || {}).hasScheduledSetting" #subtitle>
                <ActivationSetting />
            </template>
            <template #actionBtns>
                <v-btn class="mx-1" outlined text :to="editUrl"><v-icon small>mdi-square-edit-outline</v-icon>Edit {{ isPrimary ? 'Merchant' : 'Branch' }}</v-btn>
                <v-btn color="primary" class="mx-1 disabled" @click="updateSettings">Save</v-btn>
            </template>
            <template #navigationTabs>
                <v-tabs class="tabs ml-8" :v-model="activeTab">
                    <v-tab :to="$route.path">Details</v-tab>
                    <v-tab v-if="userInfo.role.id !== 'MERCHANT' && isPrimary && isPermitted(userInfo.permissions, 'merchants-branches-store')" :to="branchesUrl">Branches</v-tab>
                </v-tabs>
            </template>
        </app-bar>
        <v-container fluid>
            <QRDetails />
        </v-container>
    </div>
</template>

<script>
import AppBar from '@/components/Core/AppBar.vue';
import ActivationSetting from '@/components/Merchant/ActivationSetting.vue';
import QRDetails from '@/components/Core/QRDetails.vue';

export default {
    name: 'ViewMerchant',
    components: {
        AppBar,
        ActivationSetting,
        QRDetails
    },
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            if (from.name == 'merchant-branches') {
                vm.clearMerchant = false;
            }
        });
    },
    data() {
        return {
            activeTab: '',
            activate_at: '',
            deactivate_at: '',
            activation: 'immediate',
            deactivation: 'manual',
            activeStyle: ['white', 'rounded', 'pa-1'],
            inactiveStyle: 'btn-inactive',
            menu: false,
            menu1: false,
            menu2: false,
            isLoading: false,
            durationItems: [
                {
                    text: 'Hours',
                    value: 'HOURS'
                },
                {
                    text: 'Days',
                    value: 'DAYS'
                },
                {
                    text: 'Months',
                    value: 'MONTHS'
                },
                {
                    text: 'Years',
                    value: 'YEARS'
                }
            ],
            deactivate: {
                deactivate_setting: 'NOW',
                deactivate_at: '',
                deactivate_duration: '',
                deactivate_duration_unit: ''
            },
            sendQRFormDialog: { show: false, action: '', data: {} },
            clearMerchant: true
        };
    },
    computed: {
        reset() {
            return this.$route.fullPath.indexOf('merchants') > -1 && this.$route.fullPath.indexOf('merchants') > -1;
        },

        merchantDetails() {
            return { status: '', ...this.$store.getters['merchants/getMerchantDetails'] };
        },

        updateSettingsForm() {
            const data = this.$store.getters['merchants/getNewMerchantDetails'];
            return data || {};
        },

        editUrl() {
            return this.navigation('to', ['edit', this.merchantDetails.uuid]);
        },

        branchesUrl() {
            return this.navigation('to', ['branches'], false);
        },

        isPrimary() {
            return this.merchantDetails.classification == 'PRIMARY';
        },

        AImmediateClass() {
            if (this.activation === 'immediate') {
                return this.activeStyle;
            }

            return this.inactiveStyle;
        },

        ASchedClass() {
            if (this.activation === 'scheduled') {
                return this.activeStyle;
            }

            return this.inactiveStyle;
        },

        DManualClass() {
            if (this.deactivation === 'manual') {
                return this.activeStyle;
            }

            return this.inactiveStyle;
        },

        DSchedClass() {
            if (this.deactivation === 'scheduled') {
                return this.activeStyle;
            }

            return this.inactiveStyle;
        }
    },
    mounted() {
        this.$route.query.notif === 'true' &&
            this.$notify({
                group: 'main-notifications',
                type: 'Success',
                title: 'Successfully added new Merchant.'
            });

        if (this.clearMerchant) {
            this.$store.commit('merchants/SET_MERCHANT_DETAILS', {});
        }

        let id = this.$route.params.branch ? this.$route.params.branch : this.$route.params.id;
        const config = {
            params: { appends: ['primary_merchant', 'qr_base64'] }
        };

        if (id) {
            this.$store.dispatch('merchants/findMerchant', { id: id, config }).catch(() => {
                this.$router.push(this.navigation('back'));
            });
        } else {
            this.$store.dispatch('merchants/findMyMerchant', { config }).catch(() => {
                this.$router.push(this.navigation('back'));
            });
        }
    },

    watch: {
        activate_at(newVal) {
            this.updateStore(newVal, 'activate_at');
        },

        '$store.state.merchants.newMerchantDetails.deactivate_setting': function (newVal) {
            if (newVal === 'BY_DATE') {
                this.updateStore('', 'deactivate_duration_unit');
                this.updateStore('', 'deactivate_duration');
            } else if (newVal === 'BY_DURATION') {
                this.updateStore('', 'deactivate_at');
            } else {
                this.updateStore('', 'deactivate_duration');
                this.updateStore('', 'deactivate_duration_unit');
                this.updateStore('', 'deactivate_at');
            }
        },

        'deactivate.deactivate_setting': function (newVal) {
            if (newVal === 'BY_DATE') {
                this.deactivate.deactivate_duration_unit = '';
                this.deactivate.deactivate_duration = '';
            } else if (newVal === 'BY_DURATION') {
                this.deactivate.deactivate_at = '';
            } else {
                this.deactivate.deactivate_duration = '';
                this.deactivate.deactivate_duration_unit = '';
                this.deactivate.deactivate_at = '';
            }
        },

        deactivate_at(newVal) {
            this.updateStore(newVal, 'deactivate_at');
        }
    },
    methods: {
        updateStore(e, type) {
            this.$store.commit('merchants/SET_NEW_MERCHANT_DETAILS', { [type]: e });
        },
        toggleSetting(type, val) {
            switch (type) {
                case 'activate':
                    if (val === 'immediate') {
                        this.activation = 'immediate';
                        this.activate_at = '';
                        this.menu1 = false;
                    } else {
                        this.activation = 'scheduled';
                    }
                    break;
                case 'deactivate':
                    if (val === 'manual') {
                        this.deactivation = 'manual';
                        this.deactivate_at = '';
                        this.menu2 = false;
                        this.updateStore('MANUAL', 'deactivate_setting');
                    } else {
                        this.deactivation = 'scheduled';
                        this.updateStore('BY_DATE', 'deactivate_setting');
                    }
                    break;
            }
        },
        updateSettings() {
            // if (this.merchantDetails.status === 'DEACTIVATED') {
            //     console.log(this.updateSettingsForm);
            // } else

            if (this.merchantDetails.status === 'ACTIVE') {
                // console.log(this.deactivate);
                this.deactivateHandler();
            }
        },
        activateHandler() {
            if (this.activation === 'immediate') {
                this.$store.dispatch('merchants/activateMerchant', { id: this.merchantDetails.uuid }).then(() => {});
            }

            if (this.deactivation != 'manual') {
                let reqBody = {};
                for (const [key, value] of Object.entries(this.deactivate)) {
                    if (value != '') {
                        //@TODO Remove
                        if (key === 'deactivate_at') {
                            reqBody['deactivate_at'] = value;
                            continue;
                        }
                        reqBody[key] = value;
                    }
                }
            }
        },
        deactivateHandler() {
            // console.log(this.deactivate.deactivate_setting);
            const handler = {
                NOW: () => {
                    this.$store.dispatch('merchants/deactivateMerchant', { id: this.merchantDetails.uuid }).then(() => {
                        // console.log(response);
                    });
                },
                BY_DATE: this.updateMerchant,
                BY_DURATION: this.updateMerchant
            };

            handler[this.deactivate.deactivate_setting]() || handler['NOW']();
        },
        updateMerchant() {
            // console.log(this.deactivate);
            let reqBody = {};
            for (const [key, value] of Object.entries(this.deactivate)) {
                if (value != '') {
                    if (key === 'deactivate_at') {
                        reqBody['deactivate_at'] = value;
                        continue;
                    }
                    reqBody[key] = value;
                }
            }
            this.$store.dispatch('merchants/setMerchant', {
                id: this.merchantDetails.uuid,
                data: reqBody
            });
        },
        sendQR() {
            this.sendQRFormDialog = { show: true, data: { id: this.merchantDetails.uuid, merchantName: this.merchantDetails.name } };
        },
        downloadMerchantQR(type) {
            this.$store.dispatch('merchants/downloadMerchantQR', {
                id: this.merchantDetails.uuid,
                name: this.merchantDetails.name,
                data: {
                    type: 'JPEG',
                    partner_only: type == 'partner' ? 1 : 0
                },
                config: {
                    responseType: 'blob'
                }
            });
        },
        printMerchantQR() {
            // this.$router.push({ name: 'view-merchant', params: { id: id } });
            let routeData = this.$router.resolve({ path: `/merchants/qr/${this.merchantDetails.uuid}` });
            window.open(routeData.href, '_blank');
        }
    }
};
</script>

<style>
.disable-events {
    pointer-events: none;
    opacity: 0.75;
}

.success-1 {
    color: #27ae60;
    background-color: #e1f7ea;
}

.cursor-pointer {
    cursor: pointer;
}
</style>
